<c-card *transloco="let t">
  <c-card-body class="px-2">

          <c-row>
            <c-col md="12" lg="6">
                <h1>{{ t('Your Geotab Devices/Vehicles') }}</h1>
            </c-col>
            <c-col  md="12" lg="6">


              <c-row class="justify-content-end">
                <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
                  <c-input-group  class="text-end">
                    <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                    <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                      <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                    </select>
                  </c-input-group>
                </c-col>
                <c-col xs="auto" class="mb-2">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                    <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                      <option value="newest">{{ t('Newest') }}</option>
                      <option value="oldest">{{ t('Oldest') }}</option>
                      <option value="name">{{ t('Name') }}</option>
                    </select>
                  </c-input-group>
                </c-col>
              </c-row>

            </c-col>
          </c-row>

          <c-card class="mb-2">
            <c-card-body>

            <c-row>

            <form cForm class="row row-cols-lg-auto g-3 align-items-left" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
              <c-col xs="auto">
                <label cLabel class="visually-hidden" for="search">
                  {{ t('Search') }}
                </label>
                <c-input-group>
                  <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                  <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
                </c-input-group>
              </c-col>

              <c-col xs="auto">
                <ng-select formControlName="enabled">
                  <ng-option value="all">{{ t('Show All') }}</ng-option>

                  @if(okService.settings.geotab && !okService.settings.order_now){
                    <ng-option value="enabled">{{ t('Enabled Only') }}</ng-option>
                  }
                  @else{
                    <ng-option value="licensed">{{ t('Licensed Only') }}</ng-option> 
                  }

                  @if(okService.settings.geotab && !okService.settings.order_now){
                    <ng-option value="disabled">{{ t('Disabled Only') }}</ng-option>
                  }
                  @else{
                    <ng-option value="disabled">{{ t('Unlicensed Only') }}</ng-option>
                  }
                  
                </ng-select>
              </c-col>

              <c-col xs="auto">
                <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Search') }}</button>
              </c-col>
              </form>

            </c-row>
              @if(okService.settings.geotab && okService.settings.order_now){
                <c-row>
                  <div class="alert alert-info d-flex align-items-center justify-content-between" role="alert">
                    <div>
                      Your Geotab Account uses <strong>Order Now</strong>. Licenses are set up in your Geotab account. 
                      If you have made changes, please click the <strong>Refresh</strong> button to update your licenses.
                    </div>
                    <button type="button" class="btn btn-info text-white" (click)="refreshLicenses()">Refresh Licenses</button>
                  </div>
                </c-row>
                }

            </c-card-body>
          </c-card>


          <c-row *ngIf="vehicles">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    @if(okService.settings.geotab && !okService.settings.order_now){<th scope="col">{{ t('Enabled') }}</th> }
                    @if(okService.settings.geotab && okService.settings.order_now){<th scope="col">{{ t('Licensed') }}</th> }
                    <th scope="col">{{ t('Name') }}</th>
                    <th scope="col">{{ t('Serial') }}</th>
                    <th scope="col">{{ t('Assigned') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let vehicle of vehicles">
                      @if(okService.settings.geotab && !okService.settings.order_now){
                        <td>
                          <button type="button" class="btn btn-primary btn-sm text-white" [class.btn-success]="vehicle.enabled" [class.btn-secondary]="!vehicle.enabled" (click)="toggleEnabled(vehicle)">
                            <span *ngIf="vehicle.enabled">{{ t('Enabled') }}</span>
                            <span *ngIf="!vehicle.enabled">{{ t('Disabled') }}</span>
                          </button>
                        </td>
                      }
                      @if(okService.settings.geotab && okService.settings.order_now){
                      <td>
                        <button type="button" class="btn btn-primary btn-sm text-white" [class.btn-success]="vehicle.license" [class.btn-secondary]="!vehicle.licensed">
                          <span *ngIf="vehicle.license">{{ t('Licensed') }}</span>
                          <span *ngIf="!vehicle.license">{{ t('Unlicensed') }}</span>
                        </button>
                      </td>
                    }
                      <td>
                        <span class="fs-5">{{vehicle.name}}</span>
                      </td>
                      <td>
                        <div class="small text-medium-emphasis">
                          <span>{{vehicle.serial}}</span>
                        </div>
                      </td>

                      <td>

                        <span *ngFor="let driver of vehicle.drivers" class="badge bg-secondary m-1">{{driver.name}}</span>

                      </td>

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

  </c-card-body>
</c-card>
